'use client';

import { Trans } from '@lingui/react';
import { Alert } from '@startuptools/ui/Alert';
import { Box } from '@startuptools/ui/Box';
import { Button } from '@startuptools/ui/Button';
import { Stack } from '@startuptools/ui/Stack';
import { GqlMeetingKind } from '../graphql/base-types.graphql';
import { ReactNode } from 'react';

interface RequireMeetingProps {
  meetingKind: GqlMeetingKind | undefined;
  navigateToMeetingStep: () => void;
  skip: () => void;
  requiresUpdateMessage: ReactNode;
  requiresCreateMessage: ReactNode;
  children: ReactNode;
}

export const RequireMeeting = ({
  meetingKind,
  navigateToMeetingStep,
  skip,
  requiresUpdateMessage,
  requiresCreateMessage,
  children,
}: RequireMeetingProps) => {
  const canDoAction =
    meetingKind && [GqlMeetingKind.ShareholdersMeeting, GqlMeetingKind.ExtraShareholdersMeeting].includes(meetingKind);

  if (!canDoAction) {
    return (
      <Stack gap={2}>
        <Alert
          endDecorator={
            <Button variant="outlined" color="neutral" onClick={navigateToMeetingStep}>
              {meetingKind ? <Trans id="Update Meeting" /> : <Trans id="Create Meeting" />}
            </Button>
          }
        >
          {meetingKind ? requiresUpdateMessage : requiresCreateMessage}
        </Alert>
        <Box>
          <Button type="submit" onClick={skip}>
            <Trans id="Skip" />
          </Button>
        </Box>
      </Stack>
    );
  }

  return children;
};
